(function($) {

	'use strict';

	var init = function() {
        widthByHeight();

		marginHomeBackgroundFixed()
	};

	var widthByHeight = function(){

        var newWidth = $('.widthByHeight').outerHeight() / 2 / 0.37;
        $('.widthByHeight').width(newWidth);

	};

	var marginHomeBackgroundFixed = function() {

		var testimonyHeight = $('.homeTestimony').outerHeight(true) + 80
		$(window).resize(function() {
			if($(window).width() > 992) {
				$('.homeBackground').css('margin-top', '-'+testimonyHeight+'px')
			}
		}).resize()

	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
